import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function badge(theme: Theme): ComponentStyle {
  return {
    componentName: 'badge',
    baseStyle: {
      padding: `${theme.space['2xs']} ${theme.space['2xs']} ${theme.space['2xs']} ${theme.space['2xs']}`
    },
    variants: {
      marketTag: {
        backgroundColor: theme.colors.foreground
      }
    }
  };
}
